module.exports = __webpack_public_path__ + "static/media/image.feee292e.svg";